import {
  FaFileInvoiceDollar,
  FaHome,
  FaMapMarkerAlt,
  FaPercentage,
  FaUserGraduate
} from 'react-icons/fa';

export const primaryNavigation = [
  { to: '/dashboard', label: 'Dashboard', icon: FaHome },
  {
    to: '/students',
    label: 'Students',
    icon: FaUserGraduate,
    matchPaths: ['/students', '/families', '/directory']
  },
  {
    to: '/vouchers',
    label: 'Vouchers',
    icon: FaFileInvoiceDollar,
    matchPaths: ['/vouchers', '/voucher-status']
  },
  { to: '/locations', label: 'Locations', icon: FaMapMarkerAlt },
  { to: '/rates', label: 'Rates', icon: FaPercentage }
];
